import { useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connectToHubPedido } from "src/redux/slices/hub";
import { addPedido } from "src/redux/slices/order";
import buildHubUrl from "./buildHubUrl";
import CreateConnection from "./HubMatrix";

/**
 * Hook para manejar pedidos por usuario.
 */
export function usePedidoUserHub() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authJwt);
  const isConnectedRef = useRef(false); // Evita conexiones duplicadas

  const handleNewPedido = useCallback(
    (pedido) => {
      dispatch(addPedido(pedido));
    },
    [dispatch]
  );

  useEffect(() => {
    if (!user?.id || isConnectedRef.current) return;

    isConnectedRef.current = true;

    const cleanup = CreateConnection(
      buildHubUrl("/hub/pedidohub", { restauranteId: user.id }),
      [
        {
          id: `pedido/${user.id}`,
          operator: handleNewPedido,
        },
      ],
      dispatch,
      connectToHubPedido,
      "pedido-user"
    );

    return () => {
      cleanup();
      isConnectedRef.current = false;
    };
  }, [user?.id, dispatch, handleNewPedido]);
}

/**
 * Hook para manejar pedidos por sesión.
 */
export function usePedidoSessionHub() {
  const dispatch = useDispatch();
  const { session } = useSelector((state) => state.authJwt);
  const isConnectedRef = useRef(false); // Evita conexiones duplicadas

  const handleNewPedido = useCallback(
    (pedido) => {
      dispatch(addPedido(pedido));
    },
    [dispatch]
  );

  useEffect(() => {
    if (!session?.id || isConnectedRef.current) return;

    isConnectedRef.current = true;

    const cleanup = CreateConnection(
      buildHubUrl("/hub/pedidohub", { sessionId: session.id }),
      [
        {
          id: `pedido/session/${session.id}`,
          operator: handleNewPedido,
        },
      ],
      dispatch,
      connectToHubPedido,
      "pedido-session"
    );

    return () => {
      cleanup();
      isConnectedRef.current = false;
    };
  }, [session?.id, dispatch, handleNewPedido]);
}
